<template>
    <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
        <b-row class="bg-light mr-4 ml-4 p-2">
            <b-col cols="12" class="pb-2">
                <h3>Importe total de la categoría: {{ importe | formatear_precio }}</h3>
                <h4>¿Desea aplicar un descuento?</h4>
            </b-col>
            <b-col cols="12">
                <DescuentoComponent :data="base" index="0" :desactivar="false" :importe="importe"></DescuentoComponent>
            </b-col>
            <b-col cols="12" class="text-right mt-4">
                <Button @click="volver()" name="button" class="mr-2" :disabled="!paso_activo">ATRÁS</Button>
                <Button id="terminar-paso-4" type="submit" name="button" :disabled="!paso_activo">CONTINUAR</Button>
            </b-col>
        </b-row>
    </ValidationObserver>
</template>

<script>
import DescuentoComponent from '../../components/DescuentoComponent.vue';

export default {
    props: ['base', 'paso_activo'],
    computed: {
        configuracion() {
            return this.$store.getters.getConfig;
        },
        lista_abonados() {
            return this.$store.getters.getListaAbonados;
        },
        teatro() {
            return this.$store.getters.getTeatro;
        },
        importe() {
            let importe = 0;

            importe = importe + this.base.categoria_base.precio;

            if (this.base.indumentariasElegidas) {
                for (let i in this.base.indumentariasElegidas) {
                    if (this.base.indumentariasElegidas[i].incluida && this.base.indumentariasElegidas[i].unidades == 1) {
                        importe = importe + 0;
                    } else {
                        importe = importe + parseFloat(this.base.indumentariasElegidas[i].precio_total);
                    }
                }
            }

            return importe;
        }
    },
    methods: {
        async submit() {
            const isValid = await this.$refs.observer.validate();
            if (isValid) {
                this.guardarDatosComprador();
                this.$emit('terminado');
            }
        },
        guardarDatosComprador() {
            let params = {
                base: this.base,
                filters: {
                    tid: this.configuracion.hash_teatro
                }
            }

            this.$store.dispatch(this.config.getVuexAlias('front.bases.guardar-datos-deportista'), params).then(res => {});
        },
        volver() {
            this.$emit('volver');
        }
    },
    components: {
        DescuentoComponent
    }
}
</script>